/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  //==== START:: box code ====//
  var step1 = false,
    step2 = false,
    step3 = false,
    step4 = false,
    currency = $(".product-box-form").attr("data-currency") + " ",
    tags = ".occasion.category",
    typed_text,
    selected_product_id,
    variant_id,
    product_counter,
    product_row,
    product_bottom_row,
    max_product_limit = $(".custom-box-size-meter").attr("data-max-limit"),
    max_product_mini = parseFloat($(".mini").attr("data-size")),
    max_product_regular =
      parseFloat($(".regular").attr("data-size")) + max_product_mini,
    max_product_big =
      parseFloat($(".big").attr("data-size")) + max_product_regular,
    box_size = "Mini",
    mini_variant = $(".product-box-form").attr("data-mini-variant"),
    regular_variant = $(".product-box-form").attr("data-regular-variant"),
    big_variant = $(".product-box-form").attr("data-big-variant"),
    mini_variant_price = $(".product-box-form").attr("data-mini-variant_price"),
    regular_variant_price = $(".product-box-form").attr(
      "data-regular-variant_price"
    ),
    big_variant_price = $(".product-box-form").attr("data-big-variant_price"),
    variant_limit,
    individual_space_limit,
    individual_product_count,
    current_product_limit,
    progress_bar,
    cart_total,
    selected_product_title,
    total_steps = $(".custom-box-wrapper").attr("data-total-step");
  //======= step1 =======//
  function stepOne() {
    step1 = true;
    $(".step-1-wrapper").addClass("hide");
    $(".step-2-wrapper").removeClass("hide");
    $("#step-choose-items").addClass("active");
    window.scrollTo(0, 0);
  }
  $(".step-1-wrapper a").click(function () {
    $(".step-1-wrapper a").removeClass("step1-selected");
    $(this).addClass("step1-selected");
    $(".selected-box-color").val($(this).attr("data-title"));
    $(".previous-btn").removeClass("hide");
    if (product_counter > 0) {
      $("#custom-giftbox-tray").removeClass("hide");
    }
    stepOne();
  });
  if (total_steps == 3) {
    stepOne();
  }

  //======= step1 =======//

  //===== filter ======//
  $(".filter-dropdown").change(function () {
    console.log("filter-dropdown");
    tags = "";
    $(".filter-dropdown").each(function () {
      tags += "." + $(this).val();
      console.log("tags", tags);
    });
    //tags = tags.substring(0,tags.length - 1);
    $(".grid-product").addClass("hide");
    $(tags).removeClass("hide");
    if ($(tags).length == 0) {
      $(".error-msg").removeClass("hide");
    } else {
      $(".error-msg").addClass("hide");
    }
  });
  $(".filter-input").keyup(function () {
    typed_text = $(this).val();
    typed_text = typed_text.toLowerCase();
    $(tags).addClass("hide");
    $(tags).each(function () {
      var product_title = $(this).attr("data-title");
      product_title = product_title.toLowerCase();
      if (product_title.indexOf(typed_text) !== -1) {
        $(this).removeClass("hide");
        $(".error-msg").addClass("hide");
      } else {
        $(".error-msg").removeClass("hide");
      }
    });
  });
  //===== filter ======//
  $(".col-occasion").change(function () {
    window.location.href = $(this).val();
  });
  
  $(".minus-selector").click(function () {
    selected_product_id = $(this).attr("data-product-id");
    individual_space_limit = $(this).attr("data-max-limit");
    $("." + selected_product_id)
      .find(".all-quantity-added")
      .text("");
    $("." + selected_product_id)
      .find(".plus-selector")
      .removeClass("limit-reached");
    product_counter =
      parseFloat(
        $("." + selected_product_id)
          .find(".cart-counter")
          .eq(0)
          .text()
      ) - 1;
    $("." + selected_product_id)
      .find(".cart-counter")
      .text(product_counter);
    current_product_limit = 0;
    individual_product_count = individual_space_limit * product_counter;
    if (product_counter == 0) {
      $("." + selected_product_id)
        .find(".initial-add-to-cart")
        .show();
      $("." + selected_product_id)
        .find(".cart-quantity-selector")
        .hide();
      $("." + selected_product_id).removeClass("hasActive");
      $("[data-product-row-id*=" + selected_product_id + "]").remove();
      //       if(current_product_limit == 0)
      //       {
      //         console.log('e')
      //         $('#custom-giftbox-tray').addClass('hide');
      //       }
    } else {
      var new_price =
        $("[data-product-row-id*=" + selected_product_id + "]")
          .find(".price")
          .attr("data-baseprice") * product_counter;
      $("[data-product-row-id*=" + selected_product_id + "]")
        .find(".price")
        .text(currency + new_price.toFixed(2));
      $("[data-product-row-id*=" + selected_product_id + "]")
        .find(".quantity")
        .text(product_counter);
      $("[data-product-row-id*=" + selected_product_id + "]").attr(
        "data-current-count",
        individual_product_count
      );
      $("[data-product-row-id*=" + selected_product_id + "]")
        .find(".quantity-badge")
        .text(product_counter);
    }
    $(".box-contents-listing-product").each(function () {
      current_product_limit += parseFloat($(this).attr("data-current-count"));
    });

    $(".grid-product").each(function (i) {
      var limit =
        current_product_limit + parseFloat($(this).attr("data-space"));
      if (limit > max_product_limit) {
        $(this).addClass("max-reached");
        $(".modal-content ." + $(this).attr("id")).addClass("max-reached");
      } else {
        $(this).removeClass("max-reached");
        $(".modal-content ." + $(this).attr("id")).removeClass("max-reached");
      }
    });
    if (
      current_product_limit > max_product_mini &&
      current_product_limit <= max_product_regular
    ) {
      box_size = "Regular";
      $(".product-select").val(regular_variant);
      $(".base-product-price").attr("data-baseprice", regular_variant_price);
      $(".base-product-price").text(regular_variant_price);
    } else if (current_product_limit > max_product_regular) {
      box_size = "Big";
      $(".product-select").val(big_variant);
      $(".base-product-price").attr("data-baseprice", big_variant_price);
      $(".base-product-price").text(big_variant_price);
    } else {
      box_size = "Mini";
      $(".product-select").val(mini_variant);
      $(".base-product-price").attr("data-baseprice", mini_variant_price);
      $(".base-product-price").text(mini_variant_price);
    }
    $(".box-size").text(box_size);
    //progress_bar = (current_product_limit / max_product_limit) * 100;
    if (progress_bar == 0) {
      progress_bar = 5;
    }
    $(".size-meter-mask").css("left", progress_bar + "%");
    $(".progress").css("width", progress_bar + "%");
    progress_text(progress_bar);
    cartSubTotal();
  });
  $(".plus-selector").click(function () {
    $("#custom-giftbox-tray").removeClass("hide");
    selected_product_id = $(this).attr("data-product-id");
    individual_space_limit = $(this).attr("data-max-limit");
    selected_product_title = $(this).attr("data-title");
    variant_limit = parseFloat($(this).attr("data-variant-inventory"));
    $("." + selected_product_id)
      .find(".all-quantity-added")
      .text("");
    $("." + selected_product_id)
      .find(".plus-selector")
      .removeClass("limit-reached");
    if (
      parseFloat(
        $("." + selected_product_id)
          .find(".cart-counter")
          .eq(0)
          .text()
      ) == variant_limit
    ) {
      $("." + selected_product_id)
        .find(".all-quantity-added")
        .text("Stock limit has been reached.");
      $("." + selected_product_id)
        .find(".plus-selector")
        .addClass("limit-reached");
      return false;
    }
    product_counter =
      parseFloat(
        $("." + selected_product_id)
          .find(".cart-counter")
          .eq(0)
          .text()
      ) + 1;

    current_product_limit = 0;
    var limit = 0;
    console.log("individual_space_limit ", individual_space_limit);
    console.log("product_counter ", product_counter);
    individual_product_count = individual_space_limit * product_counter;
    $(".box-contents-listing-product").each(function () {
      current_product_limit += parseFloat($(this).attr("data-current-count"));
    });
    current_product_limit += parseFloat(individual_space_limit);
    if (max_product_limit < current_product_limit) {
      //alert('reached');

      return false;
    }
    $(".grid-product").each(function () {
      limit = current_product_limit + parseFloat($(this).attr("data-space"));
      if (limit > max_product_limit) {
        $(this).addClass("max-reached");
        $(".modal-content ." + $(this).attr("id")).addClass("max-reached");
      } else {
        $(this).removeClass("max-reached");
        $(".modal-content ." + $(this).attr("id")).removeClass("max-reached");
      }
    });
    if (
      current_product_limit > max_product_mini &&
      current_product_limit <= max_product_regular
    ) {
      box_size = "Regular";
      $(".product-select").val(regular_variant);
      $(".base-product-price").attr("data-baseprice", regular_variant_price);
      $(".base-product-price").text(regular_variant_price);
    } else if (current_product_limit > max_product_regular) {
      box_size = "Big";
      $(".product-select").val(big_variant);
      $(".base-product-price").attr("data-baseprice", big_variant_price);
      $(".base-product-price").text(big_variant_price);
    } else {
      box_size = "Mini";
      $(".product-select").val(mini_variant);
      $(".base-product-price").attr("data-baseprice", mini_variant_price);
      $(".base-product-price").text(mini_variant_price);
    }

    $(".box-size").text(box_size);
    progress_bar = (current_product_limit / max_product_limit) * 100 + 5;
    console.log(
      progress_bar,
      current_product_limit,
      max_product_limit,
      "<<<<progress_bar"
    );
    $(".size-meter-mask").css("left", progress_bar + "%");
    $(".progress").css("width", progress_bar + "%");
    progress_text(progress_bar);

    $("." + selected_product_id)
      .find(".cart-counter")
      .text(product_counter);
    $("." + selected_product_id)
      .find(".cart-quantity-selector")
      .show();
    $("." + selected_product_id).addClass("hasActive");
    variant_id = $("." + selected_product_id).attr("data-variant-id");
    console.log(variant_id,'variant_id>>>>');
    if (product_counter == 1) {
       console.log(variant_id,'variant_idddddd>>>>');
      product_row =
        '<div class="box-contents-listing-product ajax-required" data-variant-id="' +
        variant_id +
        '" data-product-row-id="' +
        selected_product_id +
        '"data-product-space="' +
        individual_space_limit +
        '"data-current-count="' +
        individual_product_count +
        '"data-title="' +
        selected_product_title +
        '">' +
        '<img src="' +
        $(this).attr("data-image") +
        '">' +
        '<div class="box-contents-listbox-contents-listing-product-text uniform-designing-product-text quantity uniform-design">' +
        product_counter +
        "</div>" +
        '<div class="box-contents-listing-product-text product-row-title uniform-design">' +
        $(this).attr("data-title") +
        "</div>" +
        '<div class="price box-contents-listing-product-text uniform-design" data-baseprice="' +
        $(this).attr("data-money-without-price") +
        '">' +
        $(this).attr("data-price") +
        "</div>" +
        '<div class="close-button" data-remove="' +
        selected_product_id +
        '"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 37 40"><path d="M21.3 23l11-11c.8-.8.8-2 0-2.8-.8-.8-2-.8-2.8 0l-11 11-11-11c-.8-.8-2-.8-2.8 0-.8.8-.8 2 0 2.8l11 11-11 11c-.8.8-.8 2 0 2.8.4.4.9.6 1.4.6s1-.2 1.4-.6l11-11 11 11c.4.4.9.6 1.4.6s1-.2 1.4-.6c.8-.8.8-2 0-2.8l-11-11z"></path></svg></div>' +
        "</div>";
      product_bottom_row =
        '<li class="ng-scope" data-product-row-id="' +
        selected_product_id +
        '">' +
        '<a href="javascript:void(0)">' +
        '<img title ="' +
        $(this).attr("data-title") +
        '" src="' +
        $(this).attr("data-image") +
        '">' +
        '<div class="quantity-badge ng-binding">' +
        product_counter +
        "</div>" +
        "</a>" +
        "</li>";
      $(".listing-products").append(product_row);
      $(".giftbox-images").append(product_bottom_row);
      runAfterRowAppend();
    } 
    else {
       console.log(variant_id,'variant_iiiidd>>>>');
      var new_price =
        $("[data-product-row-id*=" + selected_product_id + "]")
          .find(".price")
          .attr("data-baseprice") * product_counter;
      $("[data-product-row-id*=" + selected_product_id + "]")
        .find(".price")
        .text(new_price.toFixed(2));
      $("[data-product-row-id*=" + selected_product_id + "]")
        .find(".quantity")
        .text(product_counter);
      $("[data-product-row-id*=" + selected_product_id + "]").attr(
        "data-current-count",
        individual_product_count
      );
      $("[data-product-row-id*=" + selected_product_id + "]")
        .find(".quantity-badge")
        .text(product_counter);
      console.log("new_price", new_price, product_counter);
    }
    cartSubTotal();
  });

  
  $(".initial-add-to-cart").click(function () {
    current_product_limit = 0;

    selected_product_id = $(this).attr("data-product-id");
    $(".box-contents-listing-product").each(function () {
      current_product_limit += parseFloat($(this).attr("data-current-count"));
    });
console.log('selected_product_id',selected_product_id);
    $(".grid-product").each(function () {
      var limit =
        current_product_limit + parseFloat($(this).attr("data-space"));
      if (limit > max_product_limit) {
        $(this).addClass("max-reached");
        $(".modal-content ." + $(this).attr("id")).addClass("max-reached");
      } else {
        $(this).removeClass("max-reached");
        $(".modal-content ." + $(this).attr("id")).removeClass("max-reached");
      }
    });
    current_product_limit += parseFloat(
      $(this).next().find(".plus-selector").attr("data-max-limit")
    );

    if (max_product_limit < current_product_limit) {
      return false;
    }
    $("." + selected_product_id)
      .find(".initial-add-to-cart")
      .hide();
    $(this).next().find(".plus-selector").trigger("click");
  });

  $(document).on("click", ".next-step", function () {
    window.scrollTo(0, 0);
    var content = $(this).attr("data-error");
    console.log("current_product_limit ", current_product_limit);
    if (current_product_limit == 0 || current_product_limit == undefined) {
      $("#myModal").show();
      $(".popup-content").html(content);
      return false;
    } else {
      $("#step-choose-card").addClass("active").removeClass("step-locked");
      $(".step-3-wrapper").removeClass("hide");
      $(".step-2-wrapper").addClass("hide");
      $(".step-1-wrapper").addClass("hide");
      $(".fixed-tray").addClass("hide");
      $(".previous-btn").removeClass("hide");
    }
  });
  $(document).on("click", ".quickview-trigger", function (e) {
    e.preventDefault();
    var quickview_id = $(this).attr("data-quickview");
    $("." + quickview_id).css("display", "flex");
  });
  $(document).on("click", ".close", function () {
    $(".modal-quickview").hide();
  });
  $(document).on("click", ".show-popup", function () {
    window.scrollTo(0, 0);
    $("#myModal").hide();
    var content = $(this).attr("data-error");
    if (current_product_limit == 0 || current_product_limit == undefined) {
      $("#myModal").show();
      $(".popup-content").text(content);
      return false;
    } else {
      $("#step-choose-card").addClass("active").removeClass("step-locked");
      $(".step-3-wrapper").removeClass("hide");
      $(".step-2-wrapper").addClass("hide");
      $(".step-1-wrapper").addClass("hide");
      $(".fixed-tray").addClass("hide");
      $(".previous-btn").removeClass("hide");
    }
  });
  $(document).on("click", ".show-error", function () {
    var content = $(this).attr("data-error");
    $("#myModal").show();
    $(".popup-content").html(content);
    return false;
  });
  $(document).on("click", ".close-modal", function () {
    $("#myModal").hide();
  });
  $(document).on("click", ".step3-content", function () {
    $("#myModal").hide();
    $("#selected-card-img").attr("src", $(this).find("img").attr("src"));
    $(".card-wrapper").addClass("hide");
    $(".message-section").removeClass("hide");
    $(".selected-card-input").val($(this).attr("data-card-text"));
  });
  $(document).on("click", ".change-card", function () {
    $("#myModal").hide();
    $(".card-wrapper").removeClass("hide");
    $(".message-section").addClass("hide");
  });

  //==== steps back and forward ====//
  $(document).on("click", "#step-choose-packaging", function () {
    $("#myModal").hide();
    if ($(this).hasClass("active")) {
      $(".step-1-wrapper").removeClass("hide");
      $(".step-2-wrapper").addClass("hide");
      $(".step-3-wrapper").addClass("hide");
      $(".step-4-wrapper").addClass("hide");
      $(".fixed-tray").addClass("hide");
      $(".previous-btn").addClass("hide");
    }
  });
  $(document).on("click", "#step-choose-items", function () {
    if ($(this).hasClass("active")) {
      $(".step-1-wrapper").addClass("hide");
      $(".step-2-wrapper").removeClass("hide");
      $(".step-3-wrapper").addClass("hide");
      $(".fixed-tray").removeClass("hide");
      if (total_steps != 3) {
        $(".previous-btn").removeClass("hide");
      }
    }
  });
  $(document).on("click", "#step-choose-card", function () {
    if ($(this).hasClass("active")) {
      $(".next-step").trigger("click");
    }
  });
  $(document).on("click", ".previous-btn", function () {
    if ($(".step-2-wrapper").is(":visible")) {
      $("#step-choose-packaging").trigger("click");
      $(".previous-btn").addClass("hide");
    } else if ($(".step-3-wrapper").is(":visible")) {
      $("#step-choose-items").trigger("click");
    }
  });
  //==== steps back and forward ====//
  function progress_text(progress_bar) {
    console.log(progress_bar, "<<<progress_bar>>>");
    if (progress_bar == 5) {
      $("#box-contents-listing-progress-text").text(
        "Your box is feeling empty. Start adding your items!"
      );
    } else if (progress_bar > 5 && progress_bar <= 50) {
      $("#box-contents-listing-progress-text").text(
        "You're off to a great start. Keep going!"
      );
    } else if (progress_bar > 50 && progress_bar <= 75) {
      $("#box-contents-listing-progress-text").text("Looking good!");
    } else if (progress_bar > 75 && progress_bar < 100) {
      $("#box-contents-listing-progress-text").text(
        "It's getting cozy in there, but you can squeeze more in!"
      );
    } else if (progress_bar == 100) {
      $("#box-contents-listing-progress-text").text("Your box is full!");
    }
  }
  function cartSubTotal() {
    cart_total = 0;
    $(".box-contents-listing-product").each(function () {
      cart_total += parseFloat(
        $(this).find(".quantity").text() *
          $(this).find(".price").attr("data-baseprice")
      );
    });
    $("#box-contents-listing-subtotal").text(
      "Subtotal " + cart_total.toFixed(2)
    );
    $(".subtotal").text(cart_total.toFixed(2));
    console.log(cart_total, "cart_total", currency);
  }

  var click = false;
  //==== add to cart ====//
  function runAfterRowAppend() {
    $(".close-button").click(function () {
      var delete_id = $(this).attr("data-remove");
      product_counter = 0;
      current_product_limit = 0;
      $("." + delete_id)
        .find(".initial-add-to-cart")
        .show();
      $("." + delete_id)
        .find(".cart-quantity-selector")
        .hide();
      $("." + delete_id).removeClass("hasActive");
      $("." + delete_id)
        .find(".cart-counter")
        .text(product_counter);
      $("." + delete_id)
        .find(".all-quantity-added")
        .text("");
      $("." + delete_id)
        .find(".plus-selector")
        .removeClass("limit-reached");
      $("[data-product-row-id*=" + delete_id + "]").remove();
      $(".box-contents-listing-product").each(function () {
        current_product_limit += parseFloat($(this).attr("data-current-count"));
      });
      $(".grid-product").each(function () {
        var limit =
          current_product_limit + parseFloat($(this).attr("data-space"));
        if (limit > max_product_limit) {
          $(this).addClass("max-reached");
          $(".modal-content ." + $(this).attr("id")).addClass("max-reached");
        } else {
          $(this).removeClass("max-reached");
          $(".modal-content ." + $(this).attr("id")).removeClass("max-reached");
        }
      });
      if (
        current_product_limit > max_product_mini &&
        current_product_limit <= max_product_regular
      ) {
        box_size = "Regular";
        $(".product-select").val(regular_variant);
        $(".base-product-price").attr("data-baseprice", regular_variant_price);
        $(".base-product-price").text(regular_variant_price);
      } else if (current_product_limit > max_product_regular) {
        box_size = "Big";
        $(".product-select").val(big_variant);
        $(".base-product-price").attr("data-baseprice", big_variant_price);
        $(".base-product-price").text(big_variant_price);
      } else {
        box_size = "Mini";
        $(".product-select").val(mini_variant);
        $(".base-product-price").attr("data-baseprice", mini_variant_price);
        $(".base-product-price").text(mini_variant_price);
      }
      $(".box-size").text(box_size);
      // progress_bar = (current_product_limit / max_product_limit) * 100;
      if (progress_bar == 0) {
        progress_bar = 5;
      }
      $(".size-meter-mask").css("left", progress_bar + "%");
      $(".progress").css("width", progress_bar + "%");
      progress_text(progress_bar);
      if (current_product_limit == 0) {
        console.log("e");
        $("#custom-giftbox-tray").addClass("hide");
      }
      cartSubTotal();
    });

    var seletedProductTitle = "";
    $(document).on("click", ".add-to-cart-box", function (e) {
      e.preventDefault();
      if ($(".blank-checkbox input:checked").val() != "Yes") {
        if (
          $("#to").val() == "" ||
          $("#from").val() == "" ||
          $(".message-box").val() == ""
        ) {
          $("#myModal").show();
          $(".popup-content").html("Please fill all fields.");
          return false;
        }
      } else {
        $("#to").val("");
        $("#from").val("");
        $(".message-box").val("");
      }
      $(".step-3-wrapper").addClass("hide");
      $(".step-4-wrapper").removeClass("hide");
      window.scrollTo(0, 0);
      setTimeout(function () {
        var numberOfPendingRequests = 0;
        $(".ajax-required").each(function (i) {
          var variant = $(this).attr("data-variant-id");
          if (variant != undefined && click == false) {
            numberOfPendingRequests++;
          }
        });
        var x = 1;
        $(".ajax-required").each(function (i) {
          var variant = $(this).attr("data-variant-id");
          var data_title = $(this).attr("data-title");
          var qnt_value = $(this).find(".quantity").text();
          // Start: Add properies
          var data__title_qnt =
            "(" +
            x +
            "):" +
            " " +
            "Title:" +
            data_title +
            ", Quantity: " +
            qnt_value +
            " ";
          seletedProductTitle += data__title_qnt;
          // End: Add Properties

          var selected_box_color = $(".selected-box-color").val();
          var box_number = $(".box_number").val();
          if (variant != undefined && click == false) {
            var data = {
              quantity: qnt_value,
              id: variant,
              properties: {
                "Box No": box_number,
                "Box Color": selected_box_color,
              },
            };
            jQuery.ajax({
              type: "POST",
              url: "/cart/add.js",
              async: false,
              data: data,
              dataType: "json",
              success: function () {
                numberOfPendingRequests--;
                if (numberOfPendingRequests == 0) {
                  $(".spinner").addClass("hide");
                  $(".ajax-done").removeClass("hide");
                  //$(".selected-product").val(seletedProductTitle);
                  setTimeout(function () {
                    $(".product-box-form").submit();
                  }, 200);
                }
              },
            });
          }
          x++;
        });
        click = true;
      }, 100);
    });
    $(document).on("click", ".giftbox-images li", function () {
      var target_id = $(this).attr("data-product-row-id").split("-")[1];
      $(".modal-quickview").hide();
      $(".quickview-" + target_id).css("display", "flex");
    });
  }
  //==== add to cart ====//
  $("#message").on("keypress", function () {
    console.log(this.value.length);
    var rest = 149 - this.value.length;
    if (rest >= 0) {
      $(".count-remaining").text(rest + " characters remaining");
    } else {
      return false;
    }
  });

  //==== box code ====//
  $(".btn--add-to-cart").click(function (e) {
    e.preventDefault();
    if ($("body").hasClass("template-product")) {
      return;
    }
    console.log("jzgjhgdsfh");
    if ($(".blank-checkbox input:checked").val() != "Yes") {
      if (
        $("#to").val() == "" ||
        $("#from").val() == "" ||
        $(".message-box").val() == ""
      ) {
        $("#myModal").show();
        $(".popup-content").html("Please fill all fields.");
        return false;
      }
    } else {
      $("#to").val("");
      $("#from").val("");
      $(".message-box").val("");
    }
    var variant_inventory = parseFloat(
      $(".product-variants option:selected").attr("data-quantity")
    );

    var quantity = parseFloat($("#quantity").val());
    console.log(quantity);
    jQuery.getJSON("/cart.js", function (cart) {
      if (cart.item_count > 0) {
        console.log("a");
        for (var i = 0; i < cart.items.length; i++) {
          if (
            cart.items[i].variant_id ==
            $(".product-variants option:selected").attr("value")
          ) {
            var next_limit = variant_inventory - cart.items[i].quantity;
            console.log(next_limit, ">>", cart.items.length);
            if (next_limit == 0) {
              console.log(next_limit);
              $(".all-quantity-added").text("Stock limit has been reached");
            } else if (next_limit > 0 && quantity <= next_limit) {
              console.log(next_limit, "sajdikj");
              addProduct();
            } else {
              console.log(next_limit);
              $(".all-quantity-added").text(
                "Only " + variant_inventory + " available"
              );
            }
          }
        }
        if (next_limit == undefined || next_limit == "") {
          if (quantity > variant_inventory) {
            $(".all-quantity-added").text(
              "Only " + variant_inventory + " available"
            );
          } else {
            addProduct();
          }
        }
      } else {
        if (quantity > variant_inventory) {
          $(".all-quantity-added").text(
            "Only " + variant_inventory + " available"
          );
        } else {
          addProduct();
        }
      }
    });
  });
  function addProduct(e = null) {
    console.log("addProdussfgssd>>", $(".addToCartForm").serialize());
    // e.preventDefault();
    $.ajax({
      type: "POST",
      url: "/cart/add",
      data: $(".addToCartForm").serialize(),
      success: function (cart) {
        jQuery.getJSON("/cart.js", function (cart) {
          // now have access to Shopify cart object
          $(".cart-count").removeClass("hidden-count").text(cart.item_count);
          //           $("html, body").animate({ scrollTop: 0 },500);
          $("#myModal").show();
          $(".popup-content").html(
            'Item is added to cart. <br><a href="/" >Continue Shopping?</a> <a href="/cart" class="btn ">View Cart</a>'
          );
          $(".popup-content").next().remove();
        });
      },
      error: function () {
        // window.location.href='/cart'
      },
    });
  }

  var maxHeight = Math.max.apply(
    null,
    $(".product-grid-image")
      .map(function () {
        return $(this).height();
      })
      .get()
  );
  $(".product-grid-image").css("height", maxHeight);

  //===== On Varaint vhange slider ==== //
  $(".single-option-selector").change(function () {
    var data_image_id = $(
      "#productSelect-product-template option:selected"
    ).attr("data-image-id");
    var data_slick_index = $("#" + data_image_id)
      .parent()
      .parent()
      .attr("data-slick-index");
    $(".product-photo-container").slick("slickGoTo", data_slick_index);
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

function textCounter(field, field2, maxlimit) {
  var countfield = document.getElementById(field2);
  if (field.value.length > maxlimit) {
    field.value = field.value.substring(0, maxlimit);
    return false;
  } else {
    countfield.value = maxlimit - field.value.length;
  }
}

$(window).on("load", function () {
  var x = 0;

  $.getJSON("/cart.json", function (cart) {
    var item_id = $(".product-box-form").attr("data-productid");
    $.each(cart.items, function (key, value) {
      var id = value.product_id;

      if (item_id == id) {
        x += 1;
      }
    });
    var new_number = parseFloat(x) + 1;
    $(".box_number").val(new_number);
  });
});
function boxRemove(boxNumber) {
  var data = "";
  $("[data-box=" + boxNumber + "]").each(function (i) {
    data += "updates[" + $(this).attr("data-variant") + "]=0";
    if (i != $("[data-box=" + boxNumber + "]").length - 1) {
      data += "&";
    }
  });
  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: data,
    success: function () {
      window.location.href = "/cart";
    },
    error: function () {
      window.location.href = "/cart";
    },
  });
}

//==== END:: box code ====//
$(document).on("click", ".build-popout .popout", function () {
  $(".popout").parent().toggleClass("is-visible");
});

$(document).on("click", ".new--add_to_cart", function () {
  var $el = $(this),
    target = $el.attr("data-target");
  $(target).find(".initial-add-to-cart").click();
});

$(document).on("click", ".qv_thumbnail", function () {
  var $el = $(this),
    thumbSrc = $(this).find("img").attr("data-src");
  console.log(thumbSrc);
  $el
    .parents(".product-content-wrapper")
    .find(".qv_main--image img")
    .attr("src", thumbSrc);
});

$(document).on("click", "#build-sort-list .popout-list__option", function () {
  var $el = $(this),
    value = $el.attr("data-value"),
    datatext = $el.find("span").text(),
    URL = updateQueryStringParameter(window.location.href, "sort_by", value);
  $(".popout").addClass("is-active");
  $(".popout__toggle__text[data-sort-button-text]").text(datatext);
  $(".popout-list__item").removeClass("is-active");
  $el.parent(".popout-list__item").addClass("is-active");
  console.log("URL>>", datatext);
  history.pushState({}, null, URL);
  $(".product-grid-outer").css("opacity", "0.5");
  fetch(URL)
    .then((response) => response.text())
    .then((data) => {
      var dd = $(data).find(".product-grid-outer").html();
      $(".product-grid-outer").html(dd).css("opacity", "");
    });
});

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf("?") !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, "$1" + key + "=" + value + "$2");
  } else {
    return uri + separator + key + "=" + value;
  }
}

// popup
setTimeout(function () {
  if ($(".modal__overlay--newsletter:visible").length == 0) {
    $("body").removeClass("popup_modal--active");
  } else {
    $("body").addClass("popup_modal--active");
  }

  $(".modal__overlay--newsletter .close").click(function () {
    $("body").removeClass("popup_modal--active");
  });
}, 2000);

$(document).on("click", ".new--add-to-cart", function () {
  $(this).parents(".product-item__image").find(".product-link").click();
});

$('.select_label').on('click',function() {
    var select_variant = $(this).parents('.radio__buttons').find('.select_variant').val();
    console.log(select_variant,'select_variant');
    $('.select_label').removeClass('active');
    $(`input[value="${select_variant}"]`).trigger('click').prop('checked', true);
    $(this).addClass('active');
})

$(".select_variant").change(function () {
  var input = $(this).val();
  $(this).parents(".product-item").attr("data-variant-id", input);
  console.log(input);
  $(this).parents(".product-item").find('.initial-add-to-cart').show();
  $(this).parents(".product-item").find('.cart-quantity-selector').hide();
});
